import { UserPermissions } from '@agroone/entities'
import { InjectionToken } from '@angular/core'

export const OFFLINE_PERMISSIONS = new InjectionToken<UserPermissions[]>('offlinePermissions')
